const COMPLETE_TIME = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

/**
 * Turn a typed hours fragment into HH:MM, or null if it is not a time.
 * Accepts the same shortcuts as the hours field (17:15, 1715 via live colon, 12, 9, 17h00).
 */
export function normalizeHourInput(raw) {
    if (raw == null)
        return null;
    let tempTime = String(raw).trim().replace(/[hH]/g, ':');
    if (!tempTime)
        return null;

    if (/^\d:\d{2}$/.test(tempTime))
        tempTime = `0${tempTime}`;

    switch (tempTime.length) {
        case 1:
            tempTime = `0${tempTime}:00`;
            break;
        case 2:
            tempTime += ':00';
            break;
        case 3:
            tempTime += '00';
            break;
        case 4:
            tempTime += '0';
            break;
        default:
            break;
    }

    return COMPLETE_TIME.test(tempTime) ? tempTime : null;
}

/**
 * Parse a programmation time chip: `18:00` or `18:00-23:55` / `23:00-02:00`.
 * Overnight ranges keep start > end as clocks; Kore wraps the end to the next day.
 *
 * @returns {{ start: string, end: string|null }|null}
 */
export function parseProgrammationTimeToken(raw) {
    if (raw == null)
        return null;
    const normalized = String(raw).trim().replace(/[hH]/g, ':');
    if (!normalized)
        return null;
    const parts = normalized.split(/\s*-\s*/).filter((part) => part.length > 0);
    if (parts.length < 1 || parts.length > 2)
        return null;
    const start = normalizeHourInput(parts[0]);
    if (!start)
        return null;
    if (parts.length === 1)
        return { start, end: null };
    const end = normalizeHourInput(parts[1]);
    if (!end || end === start)
        return null;
    return { start, end };
}

/**
 * Normalize a typed chip into `HH:MM` or `HH:MM-HH:MM`.
 */
export function normalizeHourRangeInput(raw) {
    const parsed = parseProgrammationTimeToken(raw);
    if (!parsed)
        return null;
    return parsed.end ? `${parsed.start}-${parsed.end}` : parsed.start;
}
